import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "contextualQuestion"
const ContextualQuestionIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 Z M13,18 L13,16 L11,16 L11,18 L13,18 Z M15.07,10.625 C15.64,10.112 16,9.392 16,8.6 C16,6.611 14.21,5 12,5 C9.79,5 8,6.611 8,8.6 L10,8.6 C10,7.61 10.9,6.8 12,6.8 C13.1,6.8 14,7.61 14,8.6 C14,9.095 13.78,9.545 13.41,9.869 L12.17,11.003 C11.45,11.66 11,12.56 11,13.55 L11,14 L13,14 C13,12.65 13.45,12.11 14.17,11.453 L15.07,10.625 Z" />
        </svg>
      }
    </span>
  )
}
export default ContextualQuestionIcon
